import { TrackingEvent } from './types';

const EventTypeKey = 'custom-tracking';

export class TrackingEventEmitter extends EventTarget {
  private events: CustomEvent<TrackingEvent>[] = [];
  private timeout: NodeJS.Timeout | undefined = undefined;

  constructor(private debounceMs = 5 * 1000) {
    super();
  }

  onEvent = (handler: (data: TrackingEvent, event: CustomEvent<TrackingEvent>) => void) => {
    const listener = (e: Event) => {
      const _event = e as CustomEvent<TrackingEvent>;
      handler(_event.detail, _event);
    };

    this.addEventListener(EventTypeKey, listener);

    return () => this.removeEventListener(EventTypeKey, listener);
  };

  track = (event: TrackingEvent, opts?: { immediate?: boolean }) => {
    const e = new CustomEvent(EventTypeKey, { detail: event });

    if (opts?.immediate) {
      this.dispatchEvent(e);
      return;
    }

    this.events.push(e);

    // Send events after
    if (!this.timeout) {
      console.debug(`[${TrackingEventEmitter.name}] Setting flush events timeout.`);
      this.timeout = setTimeout(this.flushEvents, this.debounceMs);
    }
  };

  flushEvents = () => {
    console.debug(`[${TrackingEventEmitter.name}] Flushing ${this.events.length} tracking events.`);

    for (const event of this.events) {
      this.dispatchEvent(event);
    }

    // Clear state
    this.events = [];
    this.timeout = undefined;
  };
}

export const tracking = new TrackingEventEmitter();

window.onbeforeunload = () => {
  tracking.flushEvents();
};
